import React from 'react'
import {
	Row,
	Col,
	Card,
	Image,
} from 'react-bootstrap'
import styles from './EmployersDetails.module.scss'
import 'react-day-picker/lib/style.css'
import moment from 'moment'
import PropTypes from 'prop-types'

const EmployersDetail = ({ company }) => {
	return (
		<div>
			{!company ? (
				<div className='text-center mt-3'>
					<p>Loading</p>
				</div>
			) : (
				<Card className={styles.tabsCard}>
					<Row className='align-items-center mb-5'>
						<Col md={1}>
							{
								company.avatar ? (
									<Image
										roundedCircle
										src={company.avatar}
										alt='search'
										width='80'
										height='80'
										style={{ marginRight: '5px', objectFit: 'contain', border: '1px solid #D5E8FF', padding: '10px' }}
									/>
								) : (
									<div style={{ width: '110px', height: '90px', border: '1px solid #DEE7F2' }} className='d-flex align-items-center p-2'>
										<p style={{ fontSize: '13px' }}>{company.name}</p>
									</div>
								)
							}
						</Col>
						<Col className='ms-sm-3 mt-3 mt-sm-0'>
							<h4>{company.name}</h4>
							<p className='mb-0'>{`Created on ${moment(company.createdAt).format('DD MMM YYYY')}`}</p>
						</Col>
					</Row>
					<br />

					<Row>
						<Col md={3}>
							<h6 className='lh-sm'>Company Contact</h6>
						</Col>
						<Col>
							{company.contact !== null ? (
								<p className='lh-sm'>{company.contact}</p>
							) : (
								<p className='lh-sm'>-</p>
							)}
						</Col>
					</Row>

					<Row>
						<Col md={3}>
							<h6 className='lh-sm'>UEN No</h6>
						</Col>
						<Col>
							{company.uen !== null ? (
								<p className='lh-sm'>{company.uen}</p>
							) : (
								<p className='lh-sm'>-</p>
							)}
						</Col>
					</Row>

					<Row>
						<Col md={3}>
							<h6 className='lh-sm'>Branch address</h6>
						</Col>
						<Col>
							{company.Branches ? (
								company.Branches.map((location: any, i: number) => {
									return (
										<p key={i} className='lh-sm'>{location.Address.streetAddress}</p>
									)
								})
							) : (
								<p className='lh-sm'>-</p>
							)}
						</Col>
					</Row>

					<Row>
						<Col md={3}>
							<h6 className='lh-sm'>Website</h6>
						</Col>
						<Col>
							{company.slugWeb !== null ? (
								<a className='lh-sm' href={company.slugWeb} target='_blank' rel="noreferrer">{company.slugWeb}</a>
							) : (
								<p className='lh-sm'>-</p>
							)}
						</Col>
					</Row>

					<br />
					{company.updatedAt && (
						<div className='mt-5'>
							<p className='lh-sm fst-italic mb-0'>Updates as of {moment(company.updatedAt).format('DD MMM YYYY')}</p>
						</div>
					)}
				</Card>
			)}
		</div>
	)
}

EmployersDetail.propTypes = {
	company: PropTypes.object.isRequired
}

export default EmployersDetail